/**
 * Sanitizes HTML content by allowing only specified tags and attributes.
 *
 * @param {string} html - The HTML content to be sanitized.
 * @param {string[]} allowedTags - Array of allowed HTML tags.
 * @param {Object} allowedAttributes - Object mapping tags to arrays of allowed attributes.
 * @returns {string} - Sanitized HTML content.
 */

const sanitizeHTML = (html, allowedTags = [], allowedAttributes = {}) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const walk = document.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT, null, false);
  const remove = [];

  while (walk.nextNode()) {
    const node = walk.currentNode;
    const tagName = node.tagName.toLowerCase();

    if (!allowedTags.includes(tagName)) {
      remove.push(node);
    } else {
      const attributes = Array.from(node.attributes);
      for (const { name } of attributes) {
        if (!allowedAttributes[tagName]?.includes(name)) {
          node.removeAttribute(name);
        }
      }
    }
  }

  for (const node of remove) {
    node.remove();
  }

  return doc.body.innerHTML;
};

export default sanitizeHTML;
